import React, {useContext} from 'react';
import Tabs from './Tab';
import LandingPage from '../LandingPage';
import {ThemeContext} from '../../themes/ThemeProvider';

function LookupMaintenance() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [mainTabValue, setMainTabValue] = React.useState(0);
  const tabs = ['Letter Maintenance'];

  const handleChange = (event, newValue) => {
    setMainTabValue(newValue);
  };

  return (
    <>
      <LandingPage
        title={'Letters'}
        allAntTabs={tabs}
        showTabs={true}
        tabValue={mainTabValue}
        handleTabChange={handleChange}
      >
        <div className="global-field-dash-board">
          <div className={classes.cardStyleWhite}>
            <div>{mainTabValue === 0 && <Tabs />}</div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default LookupMaintenance;
